import PropTypes from "prop-types";
import {React,useState,useEffect} from "react";


import { Row, Col, CardBody, Card, Alert, Container, Button, Input, FormFeedback, Label,Modal,ModalHeader } from "reactstrap";

//redux
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import './auth.css'


// import images
import profile from "assets/images/profile-img.png";
import logo from "assets/images/logo.svg";
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom";
import axios from 'axios'

const Login = props => {

  //meta title
  document.title = "Login | Definite Assurance";
  const [email,setEmail] = useState('')
  const [email2,setEmail2] = useState('')
  const [password, setPassword] = useState('');
  const [loginText, setLogintext] = useState('Login')
  const [modal,setModal] = useState(false)
  const navigate = useNavigate()
  const [resetText, setResettext] = useState('SEND REQUEST')
  const [validateText, setValidatetext] = useState('RESET PASSWORD')
  const [validateCode, setValidatecode] = useState('')
  const [code2,setCode2] = useState('')
  const [newPassword, setNewpassword] = useState('')
  const [confirmPassword, setConfirmpassword] = useState('')
  const [resetStep, setResetstep] = useState(0)
  const [credentials, setCredentials] = useState(null)
  const [found, setFound] = useState(0)
  const company = 'Definite'

    useEffect(()=>{
    const getCredentials =async()=>{
      const res = await fetch(`https://digitalapi.definiteassurance.com/api/getCredentials?username=${company}`)
      const data = await res.json();
      const {Username, Password} = data;
      const cred = btoa(`${Username}:${Password}`)
      setCredentials(btoa(`${Username}:${Password}`))


    }

    getCredentials()

  },[])

  useEffect(() => {
    const user = localStorage.getItem('definiteagent'); // Retrieve email
    if (user) {
        
      navigate('/dashboard')
    } else {
   
    }
  }, []);





  const userLogin=async()=>{
    if(email && password){
      if(email !== 'portaladmin'){
      setLogintext('Please wait...')
      const res = await fetch(`https://digitalapi.definiteassurance.com/api/login?email=${email}&password=${password}`,{
        method:"GET",
        headers:{
          'Authorization': `Basic ${credentials}`,
          'Content-Type': "application/json"
        }
      });
      const data = await res.json();
      const {success,exists} = data;
      if(success && exists){
        setLogintext('Login')
        localStorage.setItem('definiteagent', email);
        navigate('/dashboard')
      }
      else if(!success && exists){
        setLogintext('Login')
        toast.error('Incorrect email/password combination')
      }
      else if(!success && !exists){
        setLogintext('Login')
        toast.error('User does not exist')
      }

      }
      else{

         setLogintext('Please wait...')
      if(email=='portaladmin' && password=='Definite@321'){
        setLogintext('Login')
        localStorage.setItem('portaladmin', email);
        window.location.href = 'https://digitaladmin.definiteassurance.com';
      }
      else{
        setLogintext('Login')
        toast.error('Incorrect email/password combination')
      }
        
      }





    }
    else{
        toast.error('All fields marked * are required!')
    }
  }

  const toggle =()=>{
    setModal(!modal)
  }

  const reset =async()=>{
    if(email2 !== ''){



      setResettext('LOADING...')
      const res = await fetch(`https://digitalapi.definiteassurance.com/api/checkEmail?email=${email2}`,{
        method:"GET",
        headers:{
          "Authorization": `Basic ${credentials}`,
          "Content-Type":"application/json"
        }
      })
      const data = await res.json()
      const {success, exists} = data;
      if(success && exists){
        setFound(1)
    
        const random6Digit = () => Math.floor(100000 + Math.random() * 900000).toString();
        const code = random6Digit();
        setCode2(code)
        const res = await axios.post('https://sms.definiteassurance.com/webhook/32281578-8ed1-4b26-80f3-c68690c56eeb',{email2,code})

        setResettext('SEND REQUEST')
        setResetstep(1)

      }
      else if(!success && exists){

       const random6Digit = () => Math.floor(100000 + Math.random() * 900000).toString();
      const code = random6Digit();
      setCode2(code)
      const res = await axios.post('https://sms.definiteassurance.com/webhook/32281578-8ed1-4b26-80f3-c68690c56eeb',{email2,code})


      setResettext('SEND REQUEST')
      setResetstep(1)

        setFound(2)
      }
      else{
        setResettext('SEND REQUEST')
        toast.error('Email does not exists')
      }

    }
  }

  const validateCodes =()=>{
    if(validateCode == code2){
      
      setResetstep(2)
    }
    else{
      toast.error('Incorrect code')
    }
  }

  const resetPass = async()=>{
    if(newPassword == confirmPassword){
      setValidatetext('LOADING')
      const res = await fetch(`https://digitalapi.definiteassurance.com/api/resetPassword?email=${email2}&password=${newPassword}&found=${found}`,{
        method:"GET",
        headers:{
          "Authorization": `Basic ${credentials}`,
          "Content-Type":"application/json"
        }
      })
      const data = await res.json();
      if(data.success){
        window.location.reload(false)
      }
      else{
        setValidatetext('RESET PASSWORD')
        toast.error('Something went wrong')
      }
    }
    else{
      toast.error('Passwords do not match')
    }
  }
  



  return (
    <div className="loginBody">
      <ToastContainer />
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary-subtle" id="loginTop2">
                  <Row>
                    <Col className="col-7">
                      <div className="text-primary p-4">
                        <img src="/definitelogo.png" alt="" className="loginLogo"  />
                   
                        <h5 className="text-primary" id="welcomeText">Welcome Back !</h5>
                        <p className="loginDesc">Sign in to continue.</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/" className="logo-light-element">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    
                     
                      <div className="mb-3">
                        <Label className="form-label">Email</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          onChange={(e)=>{setEmail(e.target.value)}}
                        />

                      </div>

                      <div className="mb-3">
                        <Label className="form-label">Password</Label>
                        <Input
                          name="password"
                      
                          type="password"
                          placeholder="Enter Password"
                          onChange={(e)=>{setPassword(e.target.value)}}
                         
                        />
                      
                      </div>

                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="customControlInline"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="customControlInline"
                        >
                          Remember me
                        </label>
                      </div>

                      <div className="mt-3 d-grid">
                        <button
                          className="btn btn-primary btn-block"
                          onClick={userLogin}
                          id="loginButton"
                        >
                          {loginText}
                        </button>
                      </div>

                   

                      <div className="mt-4 text-center">
                        <Link onClick={toggle}  style={{color:'#eb2229'}}>
                          <i className="mdi mdi-lock me-1" style={{color:'#eb2229'}} />
                          Forgot your password?
                        </Link>
                      </div>
                    
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p style={{color:'#fff'}}>
                  Don&#39;t have an account ?{" "} <Link to="/register" style={{color:'#eb2229'}}>
                    {" "}
                    Signup{" "}
                  </Link>{" "}
                </p>
                <p style={{color:'#fff'}}>
                  © {new Date().getFullYear()} Definite Agents Portal. Crafted
                   by Vic Creates
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>


      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader>Reset Password</ModalHeader>
        <div className="modalContainer">

          {resetStep == 0 &&
          
            <>
              <div className="mb-3">
              <Label className="form-label">Email</Label>
              <Input
                name="email"
                className="form-control"
                placeholder="Enter email"
                type="email"
                onChange={(e)=>{setEmail2(e.target.value)}}
              />

            </div>

            <Button color='success' onClick={reset}>{resetText}</Button>
            </>
          
          }
          {resetStep == 1 &&

            <>
              <div className="mb-3">
            <Label className="form-label">CODE</Label>
            <Input
              name="email"
              className="form-control"
              placeholder="Enter code"
              type="text"
              onChange={(e)=>{setValidatecode(e.target.value)}}
            />

          </div>

          <Button color='success' onClick={validateCodes}>Validate code</Button>
            
            </>
            
          
          
          }

          {resetStep == 2 &&
            <>
             <div className="mb-3">
              <Label className="form-label">New Password</Label>
              <Input
                name="password"
            
                type="password"
                placeholder="Enter New Password"
                onChange={(e)=>{setNewpassword(e.target.value)}}
                
              />
            
            </div>

            <div className="mb-3">
              <Label className="form-label">Confirm New Password</Label>
              <Input
                name="password"
            
                type="password"
                placeholder="Confirm New Password"
                onChange={(e)=>{setConfirmpassword(e.target.value)}}
                
              />
            
            </div>
            
            <Button color='success' onClick={resetPass}>{validateText}</Button>
            </>
          
          
          }
        

        </div>
      </Modal>
    </div>
  );
};

export default withRouter(Login);

Login.propTypes = {
  history: PropTypes.object,
};
